export default "__VITE_ASSET__6XBLm8Xs__"